












import { Component,Prop } from "vue-property-decorator";
import WeixinMixin from '../shared/weixin-mixin';
import { AbsCatalog } from '@/shared/catalog.model';
import { tracking } from '@/lib/tracking';
import { getArticle } from '@/shared/api';
@Component
export default class ImagePage extends WeixinMixin {
  @Prop(String) readonly articleId!: string;
  bgimage!: string
  background = ''

  article: Article = {
    id: 0,
    thumbnail: '',
    url: '',
    title: '',
    type: ''
  };

  get categories(): Array<AbsCatalog> {
    return this.$store.getters.catalogs;
  }
  get imageTitle(): string {
    return this.article?.title ?? ''
  }

  created() {
    if (this.$route.query.bgimage) {
      this.bgimage = this.$route.query.bgimage as string
      this.background = `url(${this.bgimage})`
      const index = this.bgimage.lastIndexOf('/')
      tracking({ isAction: false, pageName : `image_${this.bgimage.substring(index + 1)}` })
    } else {
      const articleId = parseInt(this.articleId);
        getArticle(articleId).then(res => {
          this.article = res;
          this.bgimage = res.url
          window.wx.ready(() => {
            this.setupShare();
            this.setupTimelineShare();
          });
          const index = this.bgimage.lastIndexOf('/')
          tracking({ isAction: false, pageName : `image_${this.bgimage.substring(index + 1)}` })
        }).catch(err => {
          console.error('load article error', err);
          this.$router.replace('/404')
        });
    }
  }

  public setupShare() {
    if (this.article.id === 0) {
      return;
    }
    window.wx.updateAppMessageShareData({
      title: this.imageTitle,
      imgUrl: this.article.url,
      link: this.shareUrl,
      success: () => {
        console.debug('updateAppMessageShareData success!');
      },
      fail: (res: unknown) => {
        console.error('updateAppMessageShareData failed: ', res);
      }
    });
  }

  public setupTimelineShare() {
    window.wx.updateTimelineShareData({
      title: this.imageTitle,
      imgUrl: this.article.url,
      link: this.shareUrl,
      success: () => {
        console.debug('updateTimelineShareData success!');
      },
      fail: (res: unknown) => {
        console.error('updateTimelineShareData failed: ', res);
      }
    });
  }
}
